// mixins.js
import {
	reactive,
	computed,
	nextTick,
	createVNode
} from "vue";
import axios from "axios";
import {
	message,
	NotificationPlacement,
	notification
} from "ant-design-vue";
import {
	Modal
} from "ant-design-vue";
import {
	ExclamationCircleOutlined
} from "@ant-design/icons-vue";

export const myMixin = () => {
	const handleLabelWidth = 240;
	let page = reactive({
		obj: {
			startPage: 1,
			pageSize: 12,
			total: 0
		}
	});
	let theme = {
		bg: '#16ba9d',
		color: 'black'
	};
	const tableMaxHeight = window.innerHeight - 260 + "px";
	const errorMsgBox = function(notice) {
		message.error(notice);
	};
	const successMsgBox = function(notice) {
		if (!notice) {
			notice = "成功";
		}
		message.success(notice);
	};
	const random = function(length) {
		return Math.round(Math.random() * length);
	};
	const confirm = (notice, callback) => {
		Modal.confirm({
			title: "操作确认",
			icon: createVNode(ExclamationCircleOutlined),
			content: notice,
			onOk() {
				callback();
			},
			onCancel() {
				successMsgBox("取消操作");
			},
		});
	};
	//form表单提交，参数不用转换，自动修改头
	const formDataApi = (data, api) => {
		axios.defaults.headers.post["Content-Type"] = "application/form-data";
		return async () => {
			let res = null;
			try {
				res = await axios.post(api, data);
				res = res.data;
				return res;
			} catch (e) {
				errorMsgBox(e.message);
				if (_.isFunction(e)) {
					await error(e);
				}
				return "error";
			}
		};
	};

	function sizeChange(val, met, reqData) {
		page.obj.startPage = 1;
		page.obj.pageSize = val;
		reqData.data.page = page.obj;
		// getData(reqData);
		met();
	}

	function currentChange(val, met, reqData) {
		page.obj.startPage = val;
		reqData.data.page = page.obj;
		// getData(reqData);
		met();
	}
	const getData = async (reqData) => {
		if (!reqData.data.page) {
			reqData.data.page = page.obj;
		}
		return await withLoading(apiAll(reqData.data, reqData.url));
	};
	const apiAll2 = (data, api, config = {}) => {
		axios.defaults.headers.post["Content-Type"] = "application/json";
		return async () => {
			const {
				method = "POST", error, defaultValue = null
			} = config;
			let res = null;
			try {
				if (method.toUpperCase() === "GET") {
					res = await axios.get(api, data);
				} else {
					res = await axios.post(api, data);
				}
				res = res.data;
				return res;
			} catch (e) {
				// this.$message({
				//   message: e.message,
				//   type: "error",
				// });
				errorMsgBox(e.message);
				if (_.isFunction(error)) {
					await error(e);
				}
				return defaultValue;
			}
		};
	};
	const apiAll = (data, api, config = {}) => {
		axios.defaults.headers.post["Content-Type"] = "application/json";
		return async () => {
			const {
				method = "POST", error, defaultValue = null
			} = config;
			let res = null;
			try {
				if (method.toUpperCase() === "GET") {
					res = await axios.get(api, data);
				} else {
					res = await axios.post(api, data);
				}
				res = res.data;
				return res;
			} catch (e) {
				// this.$message({
				//   message: e.message,
				//   type: "error",
				// });
				errorMsgBox(e.message);
				if (_.isFunction(error)) {
					await error(e);
				}
				return defaultValue;
			}
		};
	};
	const withLoading = async (asyncFunc) => {
		let res = null;
		try {
			res = await asyncFunc();
		} catch (e) {
			console.error("WithLoading Error: ", e);
		}
		return res;
	};

	return {
		theme,
		errorMsgBox,
		successMsgBox,
		confirm,
		formDataApi,
		apiAll,
		apiAll2,
		withLoading,
		page,
		sizeChange,
		currentChange,
		getData,
		tableMaxHeight,
		handleLabelWidth,
		random
	};
};